import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { SiteVendor } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { SiteService } from 'src/app/services/site.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-site-vendors-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    '../base-grid/base-grid.component.less',
    './site-vendors-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SiteVendorsGridComponent extends BaseGridComponent {
  constructor(
    private SiteService: SiteService,
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'SiteVendor';
    this.rowModelType = 'serverSide';

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.SiteService.getSiteVendors(queryObject),
          this.SiteService.getSiteVendorCount(countQueryObject)
        ]).subscribe({
          next: ([SiteVendors, siteVendorCount]) => {
            const successObject: { rowData: SiteVendor[]; rowCount: number } = {
              rowData: SiteVendors,
              rowCount: siteVendorCount
            };

            params.success(successObject);
          },
          error: (err) => {
            console.log(err);
            params.fail();
          }
        });
      }
    };
  }
}
